import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-nchoices-modal',
  templateUrl: './nchoices-modal.component.html',
  styleUrls: ['./nchoices-modal.component.scss']
})
export class NChoicesModalComponent implements OnInit {

	/** This modal is a generic one, created to give n-number of choices to the user. Input includes a question for the user, with each choice presented as a button. */

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<NChoicesModalComponent>
	) {

	}

	ngOnInit(): void {}

	choiceSelected(choice: string) {
		this.dialogRef.close({
			choice
		});
	}

	closeModal() {
		this.dialogRef.close();
	}
}
